// extracted by mini-css-extract-plugin
export default {"createdAt":"gJmv0Atzi6XPzV9Q_zL4"};